import styled from "styled-components";
const waveBottom = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaDecorators/curva-pequena-botton-violeta.svg`;

export const Algorithms = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  background-color: var(--background-patient);
  background-image: url(${waveBottom});
  background-repeat: no-repeat;
  background-position: bottom;
  background-position-y: 125%;
`;

export const ProgramBoxes = styled.div`
  font-family: "Nunito Sans ExtraBold";
  margin: auto;
  max-width: 100%;
  min-width: 60%;
  max-height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .reaction-content {
    margin: 40px 0;
  }
  .algorithms__containerBoxes {
    background-color: var(--blue-transparent-200);
    display: flex;
    align-items: center;
    border-radius: 50px;
    margin: 0px 46px 20px;
    overflow-y: auto;
    max-height: calc(100% - 220px);
    overflow: auto;
    flex-wrap: wrap;
    justify-content: space-around;
    padding: 20px 0;
    ::-webkit-scrollbar {
      position: sticky;
    }
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 10px 10px transparent;
      margin: 30px 30px;
    }
    .box-container {
      padding: 20px;
    }
    .fade {
      animation: fadeOut 1s forwards;
    }
  }

  @media only screen and (max-width: 375px) {
    .algorithms__containerBoxes {
      margin: 0px 30px 20px;
    }
  }
`;

export const AlgorithmsDiv = styled.div`
  width: 100%;
  background: linear-gradient(
    to bottom,
    var(--title-register-color) 50%,
    var(--blue-color) 50%
  );
  display: flex;
  flex-direction: column;
  .algorithms__container {
    display: flex;
    position: relative;
    justify-content: center;
    height: 100%;
    transition: 0.2s;
    .patient-list {
      width: auto;
    }
    .patient-info-content {
      background-color: var(--background-patient);
      width: 100%;
      overflow: hidden;
    }
  }
`;

export const BoxDiv = styled.div`
  background-color: var(--title-register-color);
  cursor: pointer;
  height: 130px;
  width: 130px;
  padding: 20px;
  border-radius: 50px;
  border: 5px solid var(--white);
  box-shadow: 0px 5px 35px #3e3da980;
  display: flex;
  align-items: center;
  flex-direction: column;
  .box__iconContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--blue-color);
    color: white;
    border-radius: 15px;
    margin: 20px;
    width: 40px;
    height: 40px;
    i {
      font-size: 23px;
    }
  }
  h5 {
    color: var(--white);
    text-align: center;
    word-break: break-word;
    font-family: "Nunito";
  }
`;
